import axios from 'axios';
import { getToken, urlConfig } from './getUser';

export async function callDashboardRoute(route, filters) {
  const token = await getToken();
  const res = await axios.post(
    urlConfig.dashboardV2,
    {
      route,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...filters,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data; // { success, route, type, data }
}

// Sends multiple routes in a single request.
// Response: { success, type: "bundle", data: { kpis, graphs, ranked }, partial, failed }
export async function callDashboardRoutesBatch(routes, filters) {
  const token = await getToken();
  const res = await axios.post(
    urlConfig.dashboardV2,
    {
      routes,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...filters,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}
